var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddVendor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.302,
    height: 49.302,
    viewBox: "0 0 49.302 49.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#80764d;}.b{fill:#20253a;}.c{fill:#2eb77d;}.d{fill:#66e7ec;}.e{fill:#231f20;}.f{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.988 -0.988)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M210.1,221.8a11.7,11.7,0,1,0-11.7-11.7A11.7,11.7,0,0,0,210.1,221.8ZM210.1,210.1Zm0,0",
    transform: "translate(-171.506 -171.506)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M203.9,215.6a11.7,11.7,0,1,0-11.7-11.7A11.7,11.7,0,0,0,203.9,215.6ZM203.9,203.9Zm0,0",
    transform: "translate(-166.142 -166.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M206.273,6.2h18.384a1.672,1.672,0,0,1,1.672,1.672V26.254a1.671,1.671,0,0,1-1.672,1.671H206.273a1.671,1.671,0,0,1-1.671-1.671V7.871A1.671,1.671,0,0,1,206.273,6.2Zm0,0",
    transform: "translate(-176.873 -5.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.871,6.2H26.254a1.671,1.671,0,0,1,1.671,1.672V26.254a1.671,1.671,0,0,1-1.671,1.671H7.871A1.671,1.671,0,0,1,6.2,26.254V7.871A1.671,1.671,0,0,1,7.871,6.2Zm0,0",
    transform: "translate(-5.211 -5.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.871,204.6H26.254a1.671,1.671,0,0,1,1.671,1.671v18.384a1.671,1.671,0,0,1-1.671,1.672H7.871A1.672,1.672,0,0,1,6.2,224.656V206.273A1.671,1.671,0,0,1,7.871,204.6Zm0,0",
    transform: "translate(-5.211 -176.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M226.192,217h-1.671v7.521H217v1.671h7.521v6.685h1.671v-6.685h7.521v-1.671h-7.521Zm0,0",
    transform: "translate(-187.601 -187.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M198.534,186a12.534,12.534,0,1,0,12.534,12.534A12.534,12.534,0,0,0,198.534,186Zm0,23.4A10.863,10.863,0,1,1,209.4,198.534,10.863,10.863,0,0,1,198.534,209.4Zm0,0",
    transform: "translate(-160.779 -160.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M226.192,217h-1.671v7.521H217v1.671h7.521v6.685h1.671v-6.685h7.521v-1.671h-7.521Zm0,0",
    transform: "translate(-187.601 -187.601)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVendor);
export default __webpack_public_path__ + "static/media/add_vendor.ef864fc87e45bd7c4efc9d9edd05a8ed.svg";
export { ForwardRef as ReactComponent };